import styled from "styled-components";

export const StyledFormBase = styled.form`
  width: 100%;
  padding: 2rem;
  max-width: 516px;
  border-radius: 5px;
  background-color: var(--color-black);
  
  gap: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
